import { useMemo } from "react";
import Colors from "assets/Colors";
import { Select } from "antd";
import ArrowDown from "components/icons/ArrowDown";
import s from "./styles";

const { Option } = Select;

function CustomSelector(props) {
  const { options = [], right, value } = props;

  const { borderColor, ...restProps } = props;

  const newProps = { ...restProps, options: undefined, border: undefined };

  const sortedOptions = useMemo(() => {
    if (!Array.isArray(options)) return [];

    const sorted = options.slice().sort((a, b) => {
      const nameA =
        typeof a.name === "object" ? a.name.props.children[0] : a.name;
      const nameB =
        typeof b.name === "object" ? b.name.props.children[0] : b.name;

      if (typeof nameA === "string" && typeof nameB === "string") {
        return nameA.localeCompare(nameB);
      }
      return 0;
    });

    const allOptionIndex = sorted.findIndex(
      (o) => o.value === "all" || o.value === null
    );
    if (allOptionIndex > -1) {
      const [allOption] = sorted.splice(allOptionIndex, 1);
      sorted.unshift(allOption);
    }

    return sorted;
  }, [options]);

  return (
    <s.Container
      borderColor={borderColor || Colors.background_dividers}
      right={right}
    >
      <Select
        disabled={sortedOptions.length === 0}
        dropdownMatchSelectWidth={false}
        dropdownStyle={{ background: "white", borderRadius: "2px" }}
        size="large"
        suffixIcon={
          <ArrowDown color={borderColor || Colors.background_dividers} />
        }
        notFoundContent={<div />}
        {...newProps}
      >
        {sortedOptions.map((o, i) => (
          <Option
            key={i}
            disabled={o.disabled}
            style={{
              background: value === o.value ? Colors.primary : undefined,
              color: value === o.value ? Colors.text_on_secondary : undefined,
              height: "44px",
              borderRadius: "2px",
              fontSize: "20px",
              margin: "4px 8px",
            }}
            value={o.value}
          >
            <s.textOption>{o.name}</s.textOption>
          </Option>
        ))}
      </Select>
    </s.Container>
  );
}

export default CustomSelector;
